<h1 mat-dialog-title>Update filename convention</h1>
<mat-dialog-content class="dialog-body">
  <div class="family-badge" aria-label="Convention family">
    <span class="family-badge-label">Family</span>
    <span class="family-badge-value">{{ familyBadge }}</span>
  </div>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Name</mat-label>
    <input matInput [formControl]="nameControl" type="text" />
  </mat-form-field>

  <app-ev-convention-editor
    mode="update"
    [value]="evSeed"
    [organizationId]="data.organizationId"
    [masterSuites]="masterSuites"
    [enhancementVariants]="enhancementVariants"
    [configuredEvIds]="configuredEvIds"
    (payloadChange)="onEvEditorChange($event)"
  ></app-ev-convention-editor>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canSubmit"
    (click)="submit()"
  >
    Save
  </button>
</mat-dialog-actions>
